import { FormItem, FormWrapper, TagSelect, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "melco-shared-logic";
import InteractiveOverlay from "../../../overlay/InteractiveOverlay";
import { EnableProReportingButton } from "../../proReporting/EnableProReportingButton";
import { AddMachineGroupsFilterDrawer } from "./AddMachineGroupsFilterDrawer";
import { AddDesignFilterDrawer } from "./AddDesignFilterDrawer";
import { StatisticsConfig } from "../../../../hooks/reporting/statistics/useStatistics";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export type FiltersProps = {
  isMachineReportingAllowed: boolean;
  setStatisticsFilter: Dispatch<SetStateAction<StatisticsConfig | undefined>>;
  statisticsFilter: StatisticsConfig | undefined;
};

export const Filters: React.FC<FiltersProps> = ({
  isMachineReportingAllowed,
  statisticsFilter,
  setStatisticsFilter,
}) => {
  const { t } = useTranslation();

  const [machineGroupsFilter, setMachineGroupsFilter] = useState(
    statisticsFilter?.machineGroupsFilter ?? []
  );
  const [designsFilter, setDesignsFilter] = useState(
    statisticsFilter?.designsFilter ?? []
  );

  const machineGroupsFilterDrawer = useGenericDrawer();
  const designsFilterDrawer = useGenericDrawer();

  const {
    openDrawer: machineGroupsOpenDrawer,
    isDrawerOpen: machineGroupsIsDrawerOpen,
  } = machineGroupsFilterDrawer;

  const {
    openDrawer: designsGroupsOpenDrawer,
    isDrawerOpen: designsGroupsIsDrawerOpen,
    closeDrawer: designsGroupsCloseDrawer,
  } = designsFilterDrawer;

  useEffect(() => {
    setStatisticsFilter({
      ...statisticsFilter,
      machineGroupsFilter,
      designsFilter,
    });
  }, [machineGroupsFilter, designsFilter]);

  return (
    <>
      <Title level={5}>{t("reporting.statistics.filters.title")}</Title>
      <InteractiveOverlay
        isAllowed={isMachineReportingAllowed}
        actionComponent={
          <EnableProReportingButton
            text={t("reporting.proreporting.enablebutton")}
          />
        }
      >
        <FormWrapper layout="vertical">
          <FormItem
            label={t("reporting.statistics.filters.machineGroup.add.title")}
          >
            <TagSelect
              actionLabel={t("reporting.statistics.filters.actionlabel")}
              onActionClick={machineGroupsOpenDrawer}
              // value={
              //   isMachineReportingAllowed
              //     ? statisticsFilter?.machineGroupsFilter
              //     : fakeMachineData
              // }
              value={statisticsFilter?.machineGroupsFilter}
              onRemove={(value) =>
                setMachineGroupsFilter((prev: any) =>
                  prev.filter((item: any) => item.value !== value)
                )
              }
            />
          </FormItem>

          <FormItem label={t("reporting.statistics.filters.design.add.title")}>
            <TagSelect
              actionLabel={t("reporting.statistics.filters.actionlabel")}
              onActionClick={designsGroupsOpenDrawer}
              // value={
              //   isMachineReportingAllowed
              //     ? statisticsFilter?.designsFilter
              //     : fakeDesignData
              // }
              value={statisticsFilter?.designsFilter}
              onRemove={(value) =>
                setDesignsFilter((prev: any) =>
                  prev.filter((item: any) => item.value !== value)
                )
              }
            />
          </FormItem>
        </FormWrapper>
      </InteractiveOverlay>

      {machineGroupsIsDrawerOpen && (
        <AddMachineGroupsFilterDrawer
          machineGroupsFilterDrawer={machineGroupsFilterDrawer}
          machineGroupsFilter={machineGroupsFilter}
          setMachineGroupsFilter={setMachineGroupsFilter}
        />
      )}

      {designsGroupsIsDrawerOpen && (
        <AddDesignFilterDrawer
          designsFilterDrawer={designsFilterDrawer}
          designsFilter={designsFilter}
          setDesignsFilter={setDesignsFilter}
        />
      )}
    </>
  );
};
